import React from 'react'

interface RowData {
    [key: string]: any
}

interface DataTableProps {
    items: RowData[]
}

const GenericTableforArrayofObjects: React.FC<DataTableProps> = ({ items }) => {
    //FP-10142 Please Add an extra column names Error for your component which will display error message if the no of items is 0
    // if (items.length === 0) {
    //     return <div>No items to display.</div>
    // }
    if(items.length>0){
    const columns = Object.keys(items[0])
    const filteredColumns = columns.filter((column) => column !== 'Error')
    return (
        <table className="admin-table" style={{ marginTop: '20px' }}>
            <thead>
                <tr className="admin-row-header admin-alt-row-data">
                    {filteredColumns.map((column, index) => (
                        <th key={index} style={{ textAlign: 'left' }}>
                            {column}
                        </th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {(items.length >= 1 && items[0].Error === '') || items[0].Error === undefined ? (
                    items.map((item, index) => (
                        <tr key={index} className={index % 2 === 0 ? "admin-row-data" : "admin-alt-row-data"}>
                            {filteredColumns.map((column, columnIndex) => (
                                <td key={columnIndex}>
                                    {React.isValidElement(item[column])
                                        ? item[column]
                                        : typeof item[column] === 'object'
                                          ? JSON.stringify(item[column])
                                          : item[column]}
                                </td>
                            ))}
                        </tr>
                    ))
                ) : (
                    <td colSpan={columns.length} style={{ textAlign: 'left' }}>
                        {items[0].Error}{' '}
                    </td>
                )}
            </tbody>
        </table>
    )
}
}

export default GenericTableforArrayofObjects
